import { useMutation } from "@tanstack/react-query";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import BITextInput from "../../components/BITextInput";
import BIButton from "../../components/BIButton";
import { LogInFormValues } from "./authInterface";
import { loginSchema } from "./authDtos";
import { zodResolver } from '@hookform/resolvers/zod';
import { toast } from "react-toastify";
import { useAuthStore } from "./useAuthStore";
import { login } from "./authQueries";

const LoginForm = () => {
    const { control, handleSubmit, formState: {errors}, reset } = useForm<LogInFormValues>({
		resolver: zodResolver(loginSchema),
	});
    const navigate = useNavigate();
    const storeLogin = useAuthStore(state => state.storeLogin);

    const { mutate:loginMutation, isPending:isLoading } = useMutation({
        mutationKey: ['auth/login'],
        mutationFn: login,
    });

    const onSubmit = (formValues: LogInFormValues) => {
		formValues.email = formValues.email.trim();
		formValues.password = formValues.password.trim();

		loginMutation(formValues, {
			onSuccess(data: any) {
                console.log('login response: ',data);
                data = data.data;
				reset(); 
                const loginRes = { mfaSignIn: true, token: data.token, user:data.data.user };
				storeLogin(loginRes);
				toast.success('Sign in successful');
                navigate("/dashboard/");
			},
			onError(error: any) {
                console.log(error?.response?.data?.message)
				if (error?.response?.data?.message) {
					toast.error(error.response.data.message);
				}
                else{
                    toast.error('An error occurred please try again');
                }
			},
		});
	};

    return (
        <div className="w-full flex flex-col items-center">
            <p className="font-bold text-[24px] mb-[60px]">Sign in</p>
            <form onSubmit={handleSubmit(onSubmit)} className="w-full">
                <BITextInput
                    name="email"
                    control={control}
                    type="email"
                    placeholder="Enter your email"
                    label="Email"
                    rules={{ required: "Email is required" }}
                />
                <div className="mb-[40px]"/>
                <BITextInput
                    name="password"
                    control={control}
                    type="password"
                    placeholder="Enter your Password"
                    label="Password"
                    rules={{ required: "Password is required" }}
                />
                <div className="w-full flex justify-end mb-[60px]">
                    <p className="opacity-[0.5] cursor-pointer" onClick={()=>navigate('/auth/forgot-password')}>Forgot password?</p>
                </div>
                <BIButton text="Login" type="submit" isLoading={isLoading}/>
            </form>
        </div>
    );
};

export default LoginForm;
